// Point d'entrée : init Telegram → auth → boucle menu Game Boy ↔ partie.
import "./styles.css";
import { tg, initTelegram } from "./telegram";
import { authenticate } from "./auth";
import { renderLoading, renderError, showIntro, showStreak } from "./screens";
import { showMenu } from "./gameboy";
import { startGame } from "./game-screen";
import { refreshEntitlements } from "./entitlements";
import { detectLang } from "./game/i18n";

const root = document.getElementById("app");
if (!root) throw new Error("#app introuvable");

/** Cale le chrome Telegram (header/fond) sur le bleu d'identité du jeu. */
function setChrome(): void {
  const BLUE = "#3a5ba0";
  try {
    tg?.setHeaderColor(BLUE);
    tg?.setBackgroundColor(BLUE);
  } catch {
    /* anciennes versions : sans effet */
  }
}

async function boot(): Promise<void> {
  initTelegram();
  setChrome();
  renderLoading(root!);

  const result = await authenticate();
  if (!result.ok) {
    renderError(root!, result);
    return;
  }

  // Charge les droits possédés (boutique) avant d'afficher le menu.
  await refreshEntitlements(tg?.initData ?? "");

  // Boucle : menu (style + langue + mode) → partie → retour au menu…
  let lang = detectLang();

  // Mini-tuto au tout premier lancement (une seule fois).
  try {
    if (localStorage.getItem("the-big-dig.seen-intro") !== "1") {
      await showIntro(root!, lang);
      localStorage.setItem("the-big-dig.seen-intro", "1");
    }
  } catch {
    /* stockage indisponible : on saute le tuto */
  }

  // Daily streak : 1re connexion du jour → popup série + pièces offertes.
  if (result.streak && result.streak.reward > 0) {
    await showStreak(root!, lang, result.streak.days, result.streak.reward);
    await refreshEntitlements(tg?.initData ?? ""); // solde à jour (pièces créditées)
  }
  for (;;) {
    const choice = await showMenu(root!, lang);
    lang = choice.lang;
    await startGame(root!, choice);
  }
}

boot();
